import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
import { formatPrivacyMonthYear, roundPrivacyNumber, smoothPrivacySeries } from '../privacy/privacyDisplay';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: { color: '#cbd5e1', boxWidth: 10, usePointStyle: true },
    },
    tooltip: {
      backgroundColor: '#020617',
      borderColor: '#1e40af',
      borderWidth: 1,
      titleColor: '#f8fafc',
      bodyColor: '#cbd5e1',
    },
  },
  scales: {
    x: {
      grid: { color: 'rgba(30, 64, 175, 0.18)' },
      ticks: { color: '#94a3b8', maxRotation: 0 },
    },
    y: {
      grid: { color: 'rgba(30, 64, 175, 0.18)' },
      ticks: { color: '#94a3b8' },
    },
  },
};

export const buildKilometerEvolutionData = (releverDetails = [], view = 'cumulative', isShieldModeLevel2 = false) => {
  const kilometerData = releverDetails.map(releve => ({
    date: new Date(releve.Date),
    kilometers: Number(releve.Kilometre),
  }));

  kilometerData.sort((a, b) => a.date - b.date);

  const rawValues = kilometerData.map((entry, index) => {
    if (view !== 'reading') return entry.kilometers;
    if (index === 0) return null;

    const distance = entry.kilometers - kilometerData[index - 1].kilometers;
    return Number.isFinite(distance) && distance > 0 ? distance : null;
  });

  const values = isShieldModeLevel2
    ? smoothPrivacySeries(rawValues).map(value => (
      Number.isFinite(Number(value)) ? roundPrivacyNumber(value, 'kilometers') : value
    ))
    : rawValues;

  return {
    labels: kilometerData.map(entry => isShieldModeLevel2 ? formatPrivacyMonthYear(entry.date) : entry.date.toLocaleDateString()),
    datasets: [{
      label: view === 'reading' ? 'Kilomètres parcourus par relevé' : 'Évolution des kilomètres',
      data: values,
      borderColor: 'rgba(54, 162, 235, 1)',
      fill: false,
      tension: isShieldModeLevel2 ? 0.6 : 0.4,
    }],
  };
};

const KilometerEvolutionLineChart = ({ releverDetails, compact = false, isShieldModeLevel2 = false, view = 'cumulative' }) => {
  if (!releverDetails || releverDetails.length === 0) {
    return null;
  }

  const chartData = buildKilometerEvolutionData(releverDetails, view, isShieldModeLevel2);

  return (
    <div className={compact ? 'h-72' : ''}>
      <Line data={chartData} options={compact ? chartOptions : undefined} />
    </div>
  );
};

export default KilometerEvolutionLineChart;
